<template>
    <span>
        <btn :click="addFile" icon="fas fa-plus">Add File</btn>
        <input type="file" id="files" ref="files" multiple v-on:change="handleFileUpload()" style="visibility: hidden"/>
    </span>
</template>

<script>
    export default {
        props: [
            'budget_period_id'
        ],
        data() {
            return {
                files: ''
            };
        },
        methods: {
            addFile() {
                this.$refs.files.click();
            },
            handleFileUpload() {
                this.files = this.$refs.files.files;
                this.submitFile();
            },
            submitFile() {
                let formData = new FormData();
                for( var i = 0; i < this.files.length; i++ ) {
                    let file = this.files[i];
                    formData.append('files[' + i + ']', file);
                }
                return axios.post( url(`ajax/admin/upload-file`), formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(response => {
                    return axios.post(url(`admin/budget-file/${this.budget_period_id}/add`), response.data)
                        .then(() => {
                            this.$emit('changed');
                        })
                });
            },
        },
    }
</script>

<style>
</style>
